import events from 'events.js';
import ko from 'knockout';

// Create a list of checkboxes to manage a set of options being selected
// Example: <div data-bind="checkList: {options: allOpts, selected: myOpts}">
ko.bindingHandlers.checkList = {
    init(elem, valueAccessor) {
        while (elem.firstChild) {
            elem.removeChild(elem.firstChild);
        }
        const checkListOpts = valueAccessor();
        const selected = checkListOpts.selected;

        function removeItem(option) {
            const idx = selected.indexOf(option);
            if (idx > -1) {
                selected.splice(idx, 1);
            }
        }

        for (const option of ko.unwrap(checkListOpts.options)) {
            const input = document.createElement('input');
            input.setAttribute('type', 'checkbox');
            if (selected.indexOf(option) !== -1) {
                input.checked = true;
            }

            const label = document.createElement('span');
            label.classList.add('checkbox-label');
            label.textContent = option.name();

            const opt = document.createElement('label');
            opt.classList.add('checkbox');
            opt.appendChild(input);
            opt.appendChild(label);
            elem.appendChild(opt);

            events.listen(input, 'change', function() {
                if (input.checked) {
                    selected.push(option);
                } else {
                    removeItem(option);
                }
            });
        }
        return {controlsDescendantBindings: true};
    },
    // TODO update should check/uncheck checkboxes when selected set changes
};
